import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function saveEntity(app, params) {
  const { data } = params;
  const entity = {
    doc_type: DocType.ENTITY,
    active: util.toBoolean(data.active),
    entity_types: util.toObjectIds(
      data.entity_types,
      data.entity_type_ids,
      'entity_type_id',
    ),
    name: util.toStringText(data.name),
    first_name: util.toStringText(data.first_name),
    last_name: util.toStringText(data.last_name),
    alias: util.toStringText(data.alias),
    email: util.toStringText(data.email),
    date_of_birth: util.toStringDate(data.date_of_birth),
    birth_month: util.toStringText(data.birth_month),
    legal_age: util.toBoolean(data.legal_age),
    gender: util.toStringText(data.gender),
    contact_numbers: data.contact_numbers,
    note: util.toStringText(data.note),
    employee_start_date: data.employee_start_date
      ? util.toStringDate(data.employee_start_date)
      : null,
    employee_end_date: data.employee_end_date
      ? util.toStringDate(data.employee_end_date)
      : null,
    employee_access_enabled: util.toBoolean(data.employee_access_enabled),
    employee_locations: util.toObjectIds(
      data.employee_locations,
      data.employee_location_ids,
      'location_id',
    ),
    employee_primary_location_id: data.employee_primary_location_id || null,
    employee_roles: util.toObjectIds(
      data.employee_roles,
      data.employee_role_ids,
      'role_id',
    ),
    employee_reports_to_id: data.employee_reports_to_id || null,
    register_pin: util.toStringText(data.register_pin),
    password: util.toStringText(data.password),
    contacts: data.contacts,

    loyalty_member: util.toBoolean(data.loyalty_member),
    loyalty_number_external: data.loyalty_member
      ? util.toStringText(data.loyalty_number_external)
      : null,
    loyalty_anniversary: data.loyalty_member
      ? data.loyalty_anniversary
        ? util.toStringDate(data.loyalty_anniversary)
        : null
      : null,
    price_level_id: data.price_level_id || null,

    preferred_subsidiary_id: data.preferred_subsidiary_id || null,
    preferred_location_id: data.preferred_location_id || null,
    preferred_language_id: data.preferred_language_id || null,
    preferred_currency_id: data.preferred_currency_id || null,

    subsidiary_access: util.toObjectIds(
      data.subsidiary_access,
      data.subsidiary_access_ids,
      'subsidiary_id',
    ),
    marketing_campaigns: util.toBoolean(data.marketing_campaigns),
    custom_fields: data.custom_fields,
    is_company: util.toBoolean(data.is_company),
    company_registration_number:
      data.is_company === true
        ? util.toStringText(data.company_registration_number)
        : null,
    credit_amount: util.toCurrency(data.credit_amount),
    credit_available: util.toCurrency(data.credit_available),
    credit_on_hold: util.toBoolean(data.credit_on_hold),
    credit_on_hold_reason_id: data.credit_on_hold_reason_id || null,
    credit_on_hold_comment: util.toStringText(data.credit_on_hold_comment),
    address_details: util.toObjectArray(data.address_details),
    related_entities: data.related_entities,
    on_account: util.toBoolean(data.on_account),
    dashboard_id: data.dashboard_id || null,
    dashboard_update_access: util.toBoolean(data.dashboard_update_access),
    private_contact_details: util.toBoolean(data.private_contact_details),
  };

  if (entity && entity.is_company === false) {
    entity.date_of_birth = util.toStringDateOnly(entity.date_of_birth);
  }

  entity.contact_numbers = entity.contact_numbers.filter(
    (contactNumber) => contactNumber.value
  );

  return common.saveDoc(app, {
    source: data,
    doc: entity,
  });
}

export async function getEmployeeRoleAuthority(app, employeeId) {
  const path = `${DocType.ENTITY}/employee/role_authority`;
  const service = common.getAccountService(app, path);
  return await service.get(employeeId);
}
